import { TwoFactorMethod } from '@cks-internal/react-base';
import { CardOnFileModel, CompanyCardOnFileModel } from './CardOnFileModel';
import { OnlineBookingPhoneNumberModel } from './OnlineBookingPhoneNumberModel';

/** Business profile only; maps to `ObtProfileApproverAssignment` from the API. */
export type ObtProfileApproverAssignmentType = {
  ConfigurationId?: number | null;
  ApproverId: number;
  ApproverName?: string;
  Order: number;
};

/** One Frontier Online login linked to this contact (2FA is per Frontier user). API: PascalCase. */
export type OnlineBookingFrontierUserLinkType = {
  FrontierUserId: string;
  ContactMappingId: number;
  Email: string;
  DisplayName: string;
  CompanyName: string;
  TwoFactorEnabled: boolean;
  PreferredTwoFactorMethod: TwoFactorMethod;
  TwoFactorPhoneNumber?: string;
  /** Authorized-booker flag for this specific login mapping. */
  ObtAuthBooker?: boolean;
};

export type OnlineBookingProfileModelType = {
  Email: string | undefined;
  FirstName: string | undefined;
  LastName: string | undefined;
  LoyaltyNumbers: Array<any>;
  NickName: string | undefined;
  StaticCodings: Array<any>;
  Id: number | undefined;
  UserId: string | undefined;
  Title: string | undefined;
  /** Show in Travelers box. Must match API: `IsDisabled === !Active` on every save. */
  Active: boolean;
  /** From API (`ObtProfileModel.IsDisabled`); hidden from travelers box when true. */
  IsDisabled?: boolean;
  /** True when this contact is used as an approver in company approval configuration. */
  IsConfiguredApprover?: boolean;
  HasObtLogin: boolean;
  /** True when the traveler's single OBT login mapping is flagged as an authorized booker. */
  ObtAuthBooker?: boolean;
  ObtAccessType: ObtAccessType;
  HasMultipleMappings: boolean;
  /** Primary mapping id for this profile; used when toggling Frontier Online access off. */
  ContactMappingId?: number | null;
  LinkedFrontierUsers?: OnlineBookingFrontierUserLinkType[];
  CorporateCardOnFile: CompanyCardOnFileModel | undefined;
  CorporatePCardOnFile: CardOnFileModel | undefined;
  PersonalCardOnFile: CardOnFileModel | undefined;
  PhoneNumbers: Array<OnlineBookingPhoneNumberModel>;
  CompanyPaymentType: CompanyPaymentType;
  TwoFactorEnabled?: boolean;
  PreferredTwoFactorMethod?: TwoFactorMethod;
  TwoFactorPhoneNumber?: string;
  TwoFactorEmail: string | undefined; // this is just for display purposes.
  /** Business profile only; branch office ids for this traveler. */
  BranchOfficeIds?: number[];
  /** Business profile only; ordered contact-specific approvers. */
  AssignedApprovers?: ObtProfileApproverAssignmentType[];
  SendItinerariesViaSms?: boolean;
};

export enum ObtAccessType {
  None = 0,
  BusinessAndPersonal = 1,
  PersonalOnly = 2,
  SuperUser = 3
}

export enum CompanyPaymentType {
  Wex = 0,
  CorporateCard = 1,
  CorporatePCard = 2,
  WexAndCorporatePCards = 3
}
